import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const GraphIcon = forwardRef<SVGSVGElement, IconProps>(function GraphIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24102 3.06646C7.43698 3.06341 7.61692 3.15992 7.70129 3.31333L8.94048 5.56639H9.5C9.77614 5.56639 10 5.76052 10 6C10 6.23948 9.77614 6.43361 9.5 6.43361H8.625C8.43226 6.43361 8.25668 6.33754 8.17371 6.18667L7.27167 4.54661L5.20873 8.6725C5.13076 8.82843 4.95493 8.93049 4.75898 8.93354C4.56302 8.93659 4.38308 8.84008 4.29871 8.68667L3.05952 6.43361H2.5C2.22386 6.43361 2 6.23948 2 6C2 5.76052 2.22386 5.56639 2.5 5.56639H3.375C3.56774 5.56639 3.74332 5.66246 3.82629 5.81333L4.72833 7.45338L6.79127 3.3275C6.86924 3.17156 7.04507 3.06951 7.24102 3.06646Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.2246 8.85786C1.0663 8.14555 1 7.21833 1 6C1 4.78167 1.0663 3.85445 1.2246 3.14214C1.38208 2.43353 1.61743 2.00048 1.90261 1.7153C2.45865 1.15926 3.51052 0.86722 6 0.86722C8.48948 0.86722 9.54135 1.15926 10.0974 1.7153C10.3826 2.00048 10.6179 2.43353 10.7754 3.14214C10.9337 3.85445 11 4.78167 11 6C11 7.21833 10.9337 8.14555 10.7754 8.85786C10.6179 9.56647 10.3826 9.99952 10.0974 10.2847C9.54135 10.8407 8.48948 11.1328 6 11.1328C3.51052 11.1328 2.45865 10.8407 1.90261 10.2847C1.61743 9.99952 1.38208 9.56647 1.2246 8.85786ZM6 12C1.059 12 0 10.941 0 6C0 1.059 1.059 0 6 0C10.941 0 12 1.059 12 6C12 10.941 10.941 12 6 12Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
